export default __webpack_public_path__ + "static/media/powered-by-Viuty.0ef2a345.svg";